import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Page-level header: title (h2), optional subtitle, and optional right-aligned actions.
 * Stacks vertically on mobile, horizontally on desktop.
 */
interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  sx?: object;
}

export function PageHeader({ title, subtitle, actions, sx }: Props) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{ mb: 3, alignItems: { sm: 'center' }, justifyContent: 'space-between', ...sx }}
    >
      <Box>
        <Typography variant="h2" sx={{ mb: subtitle ? 0.5 : 0 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box>{actions}</Box>}
    </Stack>
  );
}
